import React from 'react';
import PropTypes from 'prop-types';
import WBottomBtnsBar from "../WBottomBtnsBar";

const WInfoStep = ({ options, onNext, onBack, isBackVisible, fieldName }) => {
    const handleNextClick = () => {
        const selectedOption = options[0]; // Use the first option since there's no selection process
        if (onNext && selectedOption) {
            onNext({ value: selectedOption.value, next: selectedOption.next, fieldName });
        }
    };

    const text = options[0].options.text;

    return (
        <div className="wui content-container">
            <div
                className="wui info-content"
                dangerouslySetInnerHTML={{ __html: text }} // Render HTML unsecurely
            />
            <div className="wui button-bar">
                {isBackVisible && (
                    <WBottomBtnsBar
                        onBack={() => onBack && onBack()}
                        isNextVisible={false}
                    />
                )}
                <button
                    type="button"
                    className="wui action-button"
                    onClick={handleNextClick}
                >
                    Umfassende individuelle Beratung
                </button>
            </div>
        </div>
    );
};

WInfoStep.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            next: PropTypes.string,
            options: PropTypes.shape({
                text: PropTypes.string.isRequired,
            }).isRequired,
        })
    ).isRequired,
    onNext: PropTypes.func,           // Function to handle "Next" button click
    onBack: PropTypes.func,           // Function to handle "Back" button click
    isBackVisible: PropTypes.bool,    // Whether the "Back" button should be displayed
    fieldName: PropTypes.string,      // Field name for tracking
};

export default WInfoStep;
